import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=26856795&"
import script from "./customerList.vue?vue&type=script&lang=js&"
export * from "./customerList.vue?vue&type=script&lang=js&"
import style0 from "./customerList.vue?vue&type=style&index=0&id=26856795&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports